import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Button,
  useColorModeValue,
  Select,
  Input,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCheck, FaEdit } from "react-icons/fa";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import Confirm from "./Confirm";
import LoadingPage from "./LoadingPage";

export default function ProfileUser({ logout }) {
  const [user, setUser] = useState({});
  const [gender, setGender] = useState("");
  const [edit, setEdit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);

  function getUserProfile() {
    setLoadingPage(true);
    baseService.get(
      config.services.user.getProfile,
      (res) => {
        setUser(res.data.user);
        setGender(res.data.user.gender);
        setLoadingPage(false);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  useEffect(() => {
    getUserProfile();
  }, []);

  function updateProfile(payload) {
    baseService.patch(
      config.services.user.updateProfile,
      payload,
      () => {
        setUser({ ...user, ...payload });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  return (
    <Center minHeight="var(--page-height)">
      {loadingPage && <LoadingPage />}
      <Box
        maxW={"270px"}
        w={"full"}
        bg={useColorModeValue("white", "gray.800")}
        boxShadow={"2xl"}
        rounded={"md"}
        overflow={"hidden"}
      >
        <Image
          h={"120px"}
          w={"full"}
          src={
            "https://images.unsplash.com/photo-1612865547334-09cb8cb455da?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80"
          }
          objectFit={"cover"}
        />
        <Flex justify={"center"} mt={-12}>
          <Avatar
            size={"xl"}
            src={
              !gender
                ? "https://i.pinimg.com/236x/67/bc/fd/67bcfd058da17fdc07bc2669f6935411.jpg"
                : gender === "laki-laki"
                ? "https://i.pinimg.com/originals/c4/bd/43/c4bd43d9daeb1041beb93eb0c35fd987.jpg"
                : "https://i.pinimg.com/originals/6f/ae/f2/6faef2f4a4703d8c29ca21f199258852.jpg"
            }
            alt={"Author"}
            css={{
              border: "2px solid white",
            }}
          />
        </Flex>

        <Box p={6}>
          <Stack spacing={0} align={"center"} mb={5}>
            <Flex alignItems="center" position="relative">
              {edit ? (
                <Input
                  defaultValue={user.name}
                  onChange={(e) => setUser({ ...user, name: e.target.value })}
                />
              ) : (
                <Heading
                  fontSize={"2xl"}
                  fontWeight={500}
                  fontFamily={"body"}
                  textAlign="center"
                >
                  {user.name}
                </Heading>
              )}
              {user.role !== "admin" && (
                <Box
                  position="absolute"
                  right={-4}
                  cursor="pointer"
                  onClick={() => setEdit(!edit)}
                >
                  {edit ? (
                    <FaCheck
                      fontSize={12}
                      color="gray"
                      onClick={() => updateProfile({ name: user.name })}
                    />
                  ) : (
                    <FaEdit fontSize={12} color="gray" />
                  )}
                </Box>
              )}
            </Flex>
            <Text color={"gray.500"}>{user.role}</Text>
          </Stack>

          {user.role !== "admin" && (
            <Stack direction={"row"} justify={"center"} spacing={6}>
              <Select
                disabled={user.gender ? true : false}
                variant="filled"
                placeholder="Gender"
                value={user.gender}
                onChange={(e) => {
                  e.target.value && setOpenModal(!openModal);
                  setGender(e.target.value);
                }}
              >
                <option value="laki-laki">Laki-laki</option>
                <option value="perempuan">Perempuan</option>
              </Select>
            </Stack>
          )}

          <Button
            w={"full"}
            mt={6}
            bg={useColorModeValue("#151f21", "gray.900")}
            color={"white"}
            rounded={"md"}
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg",
            }}
            onClick={logout}
          >
            Keluar
          </Button>
        </Box>
      </Box>
      <Confirm
        content={{
          title: "Konfirmasi",
          desc: `Apakah anda ${gender}?`,
        }}
        active={openModal}
        onCancel={() => setOpenModal(!openModal)}
        callback={() => updateProfile({ gender: gender })}
      />
    </Center>
  );
}
